import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, WarningCircle, XCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useStudent } from "@/context/StudentContext";
import { PageHeader } from "@/components/PageHeader";

const STATUS = {
  Hadir: { color: "text-green-600", bg: "bg-green-50", icon: CheckCircle },
  Izin: { color: "text-amber-600", bg: "bg-amber-50", icon: WarningCircle },
  Sakit: { color: "text-orange-600", bg: "bg-orange-50", icon: WarningCircle },
  Alpha: { color: "text-destructive", bg: "bg-red-50", icon: XCircle },
};

export default function Absensi() {
  const [params] = useSearchParams();
  const { activeId } = useStudent();
  const sid = params.get("student") || activeId;
  const [list, setList] = useState([]);

  useEffect(() => {
    if (sid) api.get(`/attendance?student_id=${sid}`).then((r) => setList(r.data));
  }, [sid]);

  const today = list[0];
  const st = today ? STATUS[today.status] || STATUS.Hadir : null;

  return (
    <div>
      <PageHeader title="Absensi" />
      <div className="px-5 pt-4">
        {today && (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
            className={`rounded-3xl p-5 mb-5 ${today.status === "Hadir" ? "bg-primary text-white" : "bg-white border border-stone-200"}`}>
            <p className={`text-xs ${today.status === "Hadir" ? "text-white/70" : "text-stone-400"}`}>
              {new Date(today.date).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long" })}
            </p>
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center gap-2">
                {st && <st.icon size={30} weight="fill" className={today.status === "Hadir" ? "text-white" : st.color} />}
                <span className="font-heading text-2xl font-bold">{today.status}</span>
              </div>
              {today.time_in && (
                <div className={`text-right text-xs ${today.status === "Hadir" ? "text-white/80" : "text-stone-500"}`}>
                  <p>Masuk {today.time_in}</p>
                  {today.time_out && <p>Pulang {today.time_out}</p>}
                </div>
              )}
            </div>
          </motion.div>
        )}

        <h3 className="font-heading font-semibold text-stone-800 mb-3">Riwayat Kehadiran</h3>
        <div className="space-y-2">
          {list.map((a, i) => {
            const s = STATUS[a.status] || STATUS.Hadir;
            return (
              <motion.div
                key={a.id || i}
                data-testid={`attendance-${i}`}
                initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }}
                className="bg-white rounded-2xl border border-stone-200/60 p-3.5 flex items-center justify-between shadow-sm"
              >
                <span className="text-stone-700 text-sm">{new Date(a.date).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "short" })}</span>
                <span className={`flex items-center gap-1.5 text-sm font-semibold ${s.color}`}>
                  <s.icon size={16} weight="fill" /> {a.status}
                </span>
              </motion.div>
            );
          })}
          {list.length === 0 && <p className="text-center text-stone-400 mt-8">Belum ada data absensi.</p>}
        </div>
      </div>
    </div>
  );
}
